import { format, startOfWeek, addDays } from "date-fns";

export interface DateShortcuts {
  today: Date;
  yesterday: Date;
}

export function dateShortcuts(): DateShortcuts {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return { today, yesterday };
}

const oneDay = 86400000;

export function daysSince(first: Date) {
  return Math.floor((Date.now() - first.valueOf()) / oneDay);
}

export function isSameDay(dateA: Date, dateB: Date) {
  return dateA.toDateOnlyString() === dateB.toDateOnlyString();
}

export function minutesBetween(dateA: Date, dateB: Date) {
  var timeDifference = Math.abs(dateB.getTime() - dateA.getTime());
  var minutesDifference = Math.floor(timeDifference / 1000 / 60);
  return minutesDifference;
}

export function isExpiring(expires_at?: number): boolean {
  const epochTime = Math.floor(Date.now() / 1000);
  const expires_in = expires_at ? expires_at - epochTime : null;
  const expiring = expires_in && expires_in < 300;
  return !!expiring;
}

export function timeSince(date: Date): string {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  const seconds = Math.floor(diffMs / 1000);
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;

  const days = Math.floor(hours / 24);
  return `${days}d`;
}

export const formatDate = (date: Date) => format(date, "yyyy-MM-dd");

export const getCurrentWeekDates = (): { dates: string[]; from: string; to: string } => {
  const today = new Date();
  const weekStart = startOfWeek(today, { weekStartsOn: 1 });
  const weekDays = Array.from({ length: 7 }).map((_, i) => addDays(weekStart, i));
  const toDate = weekDays[weekDays.length - 1];
  const dates = weekDays.map((weekDay) => format(weekDay, "yyyy-MM-dd"));
  return { dates, from: dates[0], to: format(toDate, "yyyy-MM-dd") };
};

export const hasDatePassed = (date: Date) => {
  const today = new Date(formatDate(new Date()));
  const formattedDate = new Date(formatDate(date));

  return formattedDate <= today;
};

export const parseDateToString = (date: Date) => format(date, "EEEE, d MMM yyyy");
